export default __webpack_public_path__ + "static/media/car-offline.167d77c5.png";